import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";

export interface InStock {
  id?: number;
  InStockName: string;
  state: string;
  status: boolean;
  createBy?: string;
  updatedBy?: string;
  createDate?: string;
  updateDate?: string;
}
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchInStocks = createAsyncThunk(
  "InStock/fetchInStocks",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                // Handle cases like { from_date: ..., to_date: ... }
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                // Handle primitive values (string, number)
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      // const response: any = await WarehouseAxios.get(`/InStock/?${params.toString()}`);
      const response: any = await WarehouseAxios.get(`/stock/list/?${params.toString()}`);

      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchInStocks error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch In Stocks");
    }
  }
);

export const fetchOnlyAllInStocks = createAsyncThunk(
  "",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get("/InStock");
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch InStock by ID"
      );
    }
  }
);

export const exportInStockCSV = async () => {
  const response = await Axios.get("/completedTask/?export=csv", {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "completedTask.csv",
  };
};
